import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  errorNotify,
  infoNotify,
  successNotify,
} from "../../Components/ToastComponent/ToastNotification";
import { axiosAPI, axiosupload } from "../../Components/AxiosComponents/Axios";

import {
  Grid,
  Typography,
  Paper,
  Button,
  Checkbox,
  TextField,
  Autocomplete,
  Avatar,
  Box,
  IconButton,
} from "@mui/material";

import DeleteIcon from "@mui/icons-material/Delete";
import CameraAltIcon from "@mui/icons-material/CameraAlt";

import { decryptId } from "../../Components/CryptoComponent";
import TextInput from "../../Components/InputComponents/TextInput";
import TextAreaInput from "../../Components/InputComponents/TextAreaInput";
import SelectInput from "../../Components/InputComponents/SelectInput";
import CommonButton from "../../Components/InputComponents/CommonButton";

const EditCandidate = () => {
  const { id } = useParams();
  const decryptedId = decryptId(decodeURIComponent(id));
  const location = useLocation();
  const navigate = useNavigate();

  const paginationState = location?.state?.pagination || {
    page: 0,
    rowsPerPage: 25,
  };

  const filterData = location?.state?.filterData || {
    name: "",
    passport_no: "",
    profession: "",
    CountryID: "",
    job: "",
    jobStatus: "",
    start_date: "",
    end_date: "",
    branch: "",
    recruitmentProcedure: null,
    recruitmentStages: null,
    recruitmentSubProcedures: null,
    recruitmentProcedureFields: null,
  };

  const expandedIds = location?.state?.expandedIds || "";
  const open = location?.state?.open || "";

  const [candidateData, setCandidateData] = useState({
    CI_Name: "",
    CI_Alias: "",
    CI_Dateofbirth: null,
    CI_PassportNo: "",
    CI_PrimaryEmail: "",
    CI_SecondaryEmail: "",
    CI_PrimaryMobile: "",
    CI_EmergencyMobile: "",
    CI_Address: "",
    CI_IsMedical: 0,
    CI_Profession: null,
    CI_Designation: "",
    CI_YearofExp: null,
    CI_Registration_License: "",
    CI_Department1: "",
    CI_Department2: "",
    CI_Department3: "",
    CI_Registration_License_expry: "",
    CI_Last_working_date: null,
    CI_CareerGap: 0,
    CI_CareerGapDetl: "",
    CI_CREmp: [],
    CI_Branch: null,
    CI_DocOfficer: [],
    CI_Status: null,
    CI_UserName: "",
  });

  const [CI_Photo, setCI_Photo] = useState(null);
  const [previewUrl, setPreviewUrl] = useState("");
  const [professionList, setProfessionList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [yearsOFExperience, setYearsOfExperience] = useState([]);

  const [staffList, setStaffList] = useState([]);

  const filteredOptions = staffList.filter(
    (option) => !candidateData.CI_DocOfficer.includes(option.ED_Id)
  );

  const filteredOptions2 = staffList.filter(
    (option) => !candidateData.CI_CREmp.includes(option.ED_Id)
  );

  const [errors, setErrors] = useState({});

  const inputRefs = {
    CI_Name: useRef(),
    CI_PassportNo: useRef(),
    CI_Profession: useRef(),
    CI_PrimaryEmail: useRef(),
    CI_PrimaryMobile: useRef(),
    CI_Branch: useRef(),
    CI_UserName: useRef(),
  };

  const mandatoryFields = [
    { field: "CI_Name", label: "Candidate Name" },
    { field: "CI_PassportNo", label: "Passport Number" },
    { field: "CI_PrimaryEmail", label: "Primary Email", type: "email" },
    { field: "CI_PrimaryMobile", label: "Primary Mobile" },
    { field: "CI_Profession", label: "Profession" },
    { field: "CI_Branch", label: "Branch" },
    { field: "CI_Status", label: "Status" },
    { field: "CI_UserName", label: "User Name" },
  ];
  useEffect(() => {
    const firstErrorField = mandatoryFields.find(
      (field) => errors[field.field]
    );

    if (firstErrorField && inputRefs[firstErrorField.field]?.current) {
      inputRefs[firstErrorField.field].current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });

      inputRefs[firstErrorField.field].current.focus(); // optional
    }
  }, [errors]);

  // Validate the form fields
  const validateForm = () => {
    let formErrors = {};
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    const phoneRegex = /^[0-9]{10}$/; // 10-digit phone validation
    for (let { field, label, type } of mandatoryFields) {
      const value = candidateData[field];

      if (type == "email" && !emailRegex.test(value)) {
        formErrors[field] = `Please enter a valid ${label}.`;
      } else if (!value) {
        formErrors[field] = `${label} is required.`;
      } else if (type === "phone" && !phoneRegex.test(value)) {
        formErrors[field] = `Please enter a valid ${label}.`;
      }

      if (
        candidateData.CI_Dateofbirth == "Invalid Date" ||
        candidateData?.CI_Last_working_date == "Invalid Date"
      ) {
        formErrors[`CI_Dateofbirth`] = `Date format is Invalid.`;
        formErrors[`CI_Last_working_date`] = `Date format is Invalid.`;
      }
    }
    
    setErrors(formErrors);
    if (Object.keys(formErrors).length > 0) {
      // Display the errors as toast notifications
      Object.values(formErrors).forEach((error) => {
        errorNotify(error);
      });
      return false;
    }
    return true;
  };

  const handlePictureChange = (event) => {
    const file = event.target.files[0];
    const MAX_SIZE_MB = 30;
    const MAX_SIZE_BYTES = MAX_SIZE_MB * 1024 * 1024;

    const fileSizeMB = (file.size / (1024 * 1024)).toFixed(2); // rounded to 2 decimal places

    if (file.size > MAX_SIZE_BYTES) {
      infoNotify(
        `File size should be less than ${MAX_SIZE_MB} MB. Uploaded file size is ${fileSizeMB} MB`
      );
      return;
    }

    setCI_Photo(event.target.files[0]);
    const url = URL.createObjectURL(file);
    setPreviewUrl(url);
  };

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setErrors({
      ...errors,
      [name]: "",
    });

    setCandidateData({
      ...candidateData,
      [name]: value == "" ? null : value,
    });
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();

    if (validateForm()) {
      const formData = new FormData();

      if (CI_Photo) {
        formData.append("profilePic", CI_Photo);
        // setCandidateData({...candidateData, IS_UseExisting_Image:false})
        formData.append(`IS_UseExisting_Image`, false);
      } else if (CI_Photo == null && candidateData?.CI_Photo != null) {
        // setCandidateData({...candidateData, IS_UseExisting_Image:true})
        formData.append(`IS_UseExisting_Image`, true);
      } else if (CI_Photo == null && candidateData?.CI_Photo == null) {
        // setCandidateData({...candidateData, IS_UseExisting_Image:true})
        formData.append("profilePic", null);
        formData.append(`IS_UseExisting_Image`, false);
      } else {
        // setCandidateData({...candidateData, IS_UseExisting_Image:true})
        formData.append(`IS_UseExisting_Image`, true);
      }

      Object.entries(candidateData).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          formData.append(key, JSON.stringify(value));
        } else {
          formData.append(key, value);
        }
      });

      axiosupload
        ?.put(`/Candidate/edit/${decryptedId}`, formData)
        .then((res) => {
          successNotify(res?.data?.message);
          navigate("/Candidates", {
            state: {
              pagination: paginationState,
              filterData: filterData,
              expandedIds: expandedIds,
              open: open,
            },
          });
        })
        .catch((err) => {
          console.error("Error:", err);
        });
    }
  };

  const [loading, setLoading] = useState({
    branches: false,
    yearsOFExperience: false,
    profession: false,
  });

  const getProfession = async () => {
    try {
      setLoading((prev) => ({ ...prev, profession: true }));
      const res = await axiosAPI.get(`/Profession/active/list`);
      setProfessionList(res?.data?.data || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading((prev) => ({ ...prev, profession: false }));
    }
  };

  const getYearsOfExperience = async () => {
    try {
      const res = await axiosAPI.get(`/YearofExp/active/list`);
      setYearsOfExperience(res?.data?.data || []);
    } catch (err) {
      console.error("Active API failed, retrying without 'active'", err);
      try {
        const resFallback = await axiosAPI.get(`/YearofExp/list`);
        setYearsOfExperience(resFallback?.data?.data || []);
      } catch (fallbackErr) {
        console.error("Fallback API also failed", fallbackErr);
      }
    }
  };

  const getBranches = async () => {
    try {
      setLoading((prev) => ({ ...prev, branches: true }));
      const res = await axiosAPI.get(`/Branch/active/list`);
      setBranchList(res?.data?.data || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading((prev) => ({ ...prev, branches: false }));
    }
  };

  const getStaff = async () => {
    try {
      setLoading((prev) => ({ ...prev, staffs: true }));
      const res = await axiosAPI.get(`/Employee/list`);
      setStaffList(res?.data?.data || []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading((prev) => ({ ...prev, staffs: false }));
    }
  };

  const getData = async () => {
    try {
      const res = await axiosAPI.get(`Candidate/listbyId/${decryptedId}`);

      const dataFromApi = res.data.data;

      setCandidateData(dataFromApi);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getProfession();
    getYearsOfExperience();
    getBranches();
    getStaff();
    getData();
    window.scrollTo(0, 0);
  }, []);

  return (
    <Paper
      sx={{
        padding: { xs: 2, sm: 3, md: 5 },
        margin: "auto",
        position: "relative",
        fontFamily: "Geist, sans-serif",
        minHeight: "100%",
      }}
    >
      <Typography
        variant="h5"
        sx={{ fontWeight: 600, fontFamily: "Geist, sans-serif" }}
      >
        Edit Candidate
      </Typography>

      {/* Profile Picture + Personal Information*/}
      <Grid
        container
        sx={{
          border: "1px solid lightgrey",
          borderRadius: "10px",
          padding: "20px",
        }}
        my={2}
      >
        {/* Personal Information */}
        <Grid item sx={{ padding: "5px" }} xs={12}>
          <Typography
            variant="h6"
            gutterBottom
            sx={{
              fontWeight: 600,

              fontFamily: "Geist, sans-serif",
              mt: 2,
            }}
          >
            Personal Details
          </Typography>
        </Grid>

        <Grid
          item
          xs={12}
          sm={12}
          md={4}
          lg={4}
          xl={3}
          container
          justifyContent="center"
          alignItems="center"
          sx={{ minHeight: 300 }} // Adjust height as needed
        >
          <Grid item>
            <Box sx={{ position: "relative", display: "inline-block" }}>
              {CI_Photo && previewUrl ? (
                <>
                  <label htmlFor="picture-upload">
                    <Avatar
                      src={previewUrl}
                      sx={{
                        width: 250,
                        height: 250,
                        border: "2px solid grey",
                        cursor: "pointer",
                      }}
                    />
                  </label>
                  <IconButton
                    size="small"
                    onClick={() => setCI_Photo(null)}
                    sx={{
                      position: "absolute",
                      top: -8,
                      right: -8,
                      backgroundColor: "#fff",
                      border: "1px solid #ccc",
                      zIndex: 1,
                      "&:hover": {
                        backgroundColor: "#f8d7da",
                      },
                    }}
                  >
                    <DeleteIcon sx={{ color: "#e74c3c", fontSize: 18 }} />
                  </IconButton>
                </>
              ) : candidateData?.CI_Photo ? (
                <>
                  <label htmlFor="picture-upload">
                    <Avatar
                      src={`${process.env.REACT_APP_BASE_URL}/${candidateData?.CI_Photo}`}
                      sx={{
                        width: 250,
                        height: 250,
                        border: "2px solid grey",
                        cursor: "pointer",
                      }}
                    />
                  </label>
                  <IconButton
                    size="small"
                    onClick={() => {
                      setCI_Photo(null);
                      setCandidateData({ ...candidateData, CI_Photo: null });
                    }}
                    sx={{
                      position: "absolute",
                      top: -8,
                      right: -8,
                      backgroundColor: "#fff",
                      border: "1px solid #ccc",
                      zIndex: 1,
                      "&:hover": {
                        backgroundColor: "#f8d7da",
                      },
                    }}
                  >
                    <DeleteIcon sx={{ color: "#e74c3c", fontSize: 18 }} />
                  </IconButton>
                </>
              ) : (
                <Avatar
                  sx={{
                    width: 250,
                    height: 250,
                    border: "2px solid grey",
                    cursor: "pointer",
                  }}
                >
                  <label htmlFor="picture-upload">
                    <IconButton component="span">
                      <CameraAltIcon />
                    </IconButton>
                  </label>
                </Avatar>
              )}
            </Box>
            <input
              accept="image/*"
              style={{ display: "none" }}
              id="picture-upload"
              type="file"
              onChange={handlePictureChange}
            />
          </Grid>
        </Grid>

        <Grid item xs={12} sm={12} md={8} lg={8} xl={9} container>
          {/* Full Name */}
          <Grid
            item
            sx={{ padding: "5px" }}
            xs={12}
            sm={6}
            md={6}
            lg={6}
            xl={4}
          >
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
            >
              Full Name <span style={{ color: "red" }}> * </span>
            </Typography>
            <TextInput
              label="Full Name"
              placeholder="Enter Full Name"
              name="CI_Name"
              value={candidateData.CI_Name}
              onChange={handleInputChange}
              error={!!errors.CI_Name}
              inputRef={inputRefs.CI_Name}
            />
          </Grid>

          {/* Alias */}
          <Grid
            item
            sx={{ padding: "5px" }}
            xs={12}
            sm={6}
            md={6}
            lg={6}
            xl={4}
          >
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
            >
              Alias
            </Typography>
            <TextInput
              label="Alias"
              placeholder="Enter Alias"
              name="CI_Alias"
              value={candidateData.CI_Alias}
              onChange={handleInputChange}
            />
          </Grid>

          {/* Date of Birth */}
          <Grid
            item
            sx={{ padding: "5px" }}
            xs={12}
            sm={6}
            md={6}
            lg={6}
            xl={4}
          >
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
            >
              Date of Birth
            </Typography>
            <TextInput
              label="Date of Birth"
              placeholder="Date of Birth"
              name="CI_Dateofbirth"
              value={candidateData.CI_Dateofbirth}
              onChange={handleInputChange}
              type="date"
              dateRestriction="past"
            />
          </Grid>

          {/* Passport Number */}
          <Grid
            item
            sx={{ padding: "5px" }}
            xs={12}
            sm={6}
            md={6}
            lg={6}
            xl={4}
          >
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
            >
              Passport Number <span style={{ color: "red" }}> * </span>
            </Typography>
            <TextInput
              label="Passport Number"
              placeholder="Enter Passport Number"
              type="text"
              name="CI_PassportNo"
              value={candidateData.CI_PassportNo}
              onChange={handleInputChange}
              // allowOnlyNumbers={true}

              error={!!errors.CI_PassportNo}
              inputRef={inputRefs.CI_PassportNo}
            />
          </Grid>

          {/* Email */}
          <Grid
            item
            sx={{ padding: "5px" }}
            xs={12}
            sm={6}
            md={6}
            lg={6}
            xl={4}
          >
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
            >
              Email <span style={{ color: "red" }}> * </span>
            </Typography>
            <TextInput
              label="Email Address"
              placeholder="Enter Email Address"
              type="email"
              name="CI_PrimaryEmail"
              value={candidateData.CI_PrimaryEmail}
              onChange={handleInputChange}
              error={!!errors.CI_PrimaryEmail}
              inputRef={inputRefs.CI_PrimaryEmail}
            />
          </Grid>

          {/* Secondary Email */}
          <Grid
            item
            sx={{ padding: "5px" }}
            xs={12}
            sm={6}
            md={6}
            lg={6}
            xl={4}
          >
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
            >
              Secondary Email
            </Typography>
            <TextInput
              label="Secondary Email Address"
              placeholder="Enter Secondary Email Address"
              type="email"
              name="CI_SecondaryEmail"
              value={candidateData.CI_SecondaryEmail}
              onChange={handleInputChange}
            />
          </Grid>

          {/* Mobile Number */}
          <Grid
            item
            sx={{ padding: "5px" }}
            xs={12}
            sm={6}
            md={6}
            lg={6}
            xl={4}
          >
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
            >
              Mobile <span style={{ color: "red" }}> * </span>
            </Typography>
            <TextInput
              label="Mobile Number"
              placeholder="Enter Mobile Number"
              type="text"
              name="CI_PrimaryMobile"
              value={candidateData.CI_PrimaryMobile}
              error={!!errors.CI_PrimaryMobile}
              inputRef={inputRefs.CI_PrimaryMobile}
              onChange={handleInputChange}
              allowOnlyNumbers={true}
              maxLength={15}
            />
          </Grid>

          {/* Emergency Mobile*/}
          <Grid
            item
            sx={{ padding: "5px" }}
            xs={12}
            sm={6}
            md={6}
            lg={6}
            xl={4}
          >
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
            >
              Emergency Mobile
            </Typography>
            <TextInput
              label="Emergency Mobile Number"
              placeholder="Enter Emergency Mobile"
              type="text"
              name="CI_EmergencyMobile"
              value={candidateData.CI_EmergencyMobile}
              onChange={handleInputChange}
              allowOnlyNumbers={true}
              maxLength={15}
            />
          </Grid>

          {/* Address */}
          <Grid
            item
            sx={{ padding: "5px" }}
            xs={12}
            sm={12}
            md={6}
            lg={12}
            xl={4}
          >
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
            >
              Address
            </Typography>
            <TextAreaInput
              label="Address"
              placeholder="Enter Address"
              name="CI_Address"
              value={candidateData.CI_Address}
              onChange={handleInputChange}
            />
          </Grid>
        </Grid>
      </Grid>

      {/* Professional Details*/}
      <Grid
        container
        sx={{
          border: "1px solid lightgrey",
          borderRadius: "10px",
          padding: "20px",
        }}
        my={2}
      >
        {/* Professional Details*/}
        <Grid item sx={{ padding: "5px" }} xs={12}>
          <Typography
            variant="h6"
            gutterBottom
            sx={{
              fontWeight: 600,
              fontFamily: "Geist, sans-serif",
              mt: 2,
            }}
          >
            Professional Details
          </Typography>
        </Grid>

        {/* Medical Profession*/}
        <Grid
          item
          xs={12}
          sm={5}
          md={4}
          lg={4}
          xl={3}
          sx={{
            padding: "5px",
            position: "relative",
            top: { xs: `0px`, sm: `25px` },
          }}
        >
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
          >
            Medical Profession <span style={{ color: "red" }}> * </span>
            <Checkbox
              checked={Boolean(candidateData.CI_IsMedical)}
              name="CI_IsMedical"
              onChange={(e) =>
                handleInputChange({
                  target: {
                    name: e.target.name,
                    value: e.target.checked ? 1 : 0,
                  },
                })
              }
            />
          </Typography>
        </Grid>

        {/* Profession */}
        <Grid item sx={{ padding: "5px" }} xs={12} sm={7} md={4} lg={4} xl={3}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
          >
            Profession <span style={{ color: "red" }}> * </span>
          </Typography>
          <SelectInput
            value={candidateData.CI_Profession}
            name="CI_Profession"
            onChange={handleInputChange}
            options={professionList?.map((item) => ({
              value: item?.PI_Id,
              label: item?.PI_Name,
            }))}
            placeholder="Select Profession"
            error={!!errors.CI_Profession}
            inputRef={inputRefs.CI_Profession}
            loading={loading?.profession}
          />
        </Grid>

        {/* Designation */}
        <Grid item sx={{ padding: "5px" }} xs={12} sm={6} md={4} lg={4} xl={3}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
          >
            Designation
          </Typography>
          <TextInput
            label="Designation"
            placeholder="Enter your Designation"
            name="CI_Designation"
            value={candidateData.CI_Designation}
            onChange={handleInputChange}
          />
        </Grid>

        {/*  Years of Experience  */}
        <Grid item sx={{ padding: "5px" }} xs={12} sm={6} md={4} lg={4} xl={3}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
          >
            Years of Experience
          </Typography>
          <SelectInput
            value={candidateData.CI_YearofExp}
            name="CI_YearofExp"
            onChange={handleInputChange}
            options={yearsOFExperience?.map((item) => ({
              value: item?.YEL_Id,
              label: item?.YEL_Name,
            }))}
            placeholder="Select Years of Experience"
            loading={loading?.yearsOFExperience}
          />
        </Grid>

        {/* Registration / License */}
        <Grid item sx={{ padding: "5px" }} xs={12} sm={6} md={4} lg={4} xl={3}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
          >
            Registration / License
          </Typography>
          <TextInput
            label="RegistrationLicense"
            placeholder="Enter your Registration / License Number"
            name="CI_Registration_License"
            value={candidateData.CI_Registration_License}
            onChange={handleInputChange}
          />
        </Grid>

        {/*  Registration / Licence Expiry */}
        <Grid item sx={{ padding: "5px" }} xs={12} sm={6} md={4} lg={4} xl={3}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
          >
            Registration / Licence Expiry
          </Typography>
          <TextInput
            label="Registration / Licence Expiry"
            placeholder="Enter your Registration / Licence Expiry date"
            name="CI_Registration_License_expry"
            value={candidateData.CI_Registration_License_expry}
            onChange={handleInputChange}
          />
        </Grid>

        {/* Department1 */}
        <Grid item sx={{ padding: "5px" }} xs={12} sm={6} md={4} lg={4} xl={3}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
          >
            Department 1
          </Typography>
          <TextInput
            label="Department1"
            placeholder="Enter your Department"
            name="CI_Department1"
            value={candidateData.CI_Department1}
            onChange={handleInputChange}
          />
        </Grid>

        {/* Department2 */}
        <Grid item sx={{ padding: "5px" }} xs={12} sm={6} md={4} lg={4} xl={3}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
          >
            Department 2
          </Typography>
          <TextInput
            label="Department2"
            placeholder="Enter your Department"
            name="CI_Department2"
            value={candidateData.CI_Department2}
            onChange={handleInputChange}
          />
        </Grid>

        {/* Department3 */}
        <Grid item sx={{ padding: "5px" }} xs={12} sm={6} md={4} lg={4} xl={3}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
          >
            Department 3
          </Typography>
          <TextInput
            label="Department3"
            placeholder="Enter your Department"
            name="CI_Department3"
            value={candidateData.CI_Department3}
            onChange={handleInputChange}
          />
        </Grid>

        {/* Last Working day */}
        <Grid item sx={{ padding: "5px" }} xs={12} sm={6} md={4} lg={4} xl={3}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
          >
            Last Working day
          </Typography>
          <TextInput
            label="Last Working day"
            placeholder="Last Working day"
            name="CI_Last_working_date"
            value={candidateData.CI_Last_working_date}
            onChange={handleInputChange}
            type="date"
          />
        </Grid>

        {/* Career Gap */}
        <Grid item sx={{ padding: "5px" }} xs={12} sm={6} md={4} lg={4} xl={3}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
          >
            Career Gap
          </Typography>
          <TextInput
            label="Career Gap"
            placeholder="Enter Career Gap"
            type="tel"
            name="CI_CareerGap"
            value={candidateData.CI_CareerGap}
            onChange={handleInputChange}
            allowOnlyNumbers={true}
            maxLength={3}
          />
        </Grid>

        {/* Career Gap Details */}
        <Grid item sx={{ padding: "5px" }} xs={12} sm={6} md={4} lg={4} xl={3}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
          >
            Career Gap Details
          </Typography>
          <TextAreaInput
            label="Career Gap Details"
            placeholder="Enter Career Gap Details"
            name="CI_CareerGapDetl"
            value={candidateData.CI_CareerGapDetl}
            onChange={handleInputChange}
          />
        </Grid>
      </Grid>

      {/* Other Details */}

      <Grid
        container
        sx={{
          border: "1px solid lightgrey",
          borderRadius: "10px",
          padding: "20px",
        }}
      >
        {/* Other Details */}
        <Grid item xs={12}>
          <Typography
            variant="h6"
            gutterBottom
            sx={{
              fontWeight: 600,
              marginBottom: 2,
              fontFamily: "Geist, sans-serif",
              mt: 2,
            }}
          >
            Other Details
          </Typography>
        </Grid>

        {/* CRE */}
        <Grid item sx={{ padding: "5px" }} xs={12} sm={6} md={4} lg={4} xl={3}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
          >
            CRE
          </Typography>

          <Autocomplete
            multiple
            disableCloseOnSelect
            options={filteredOptions2}
            getOptionLabel={(option) => option.ED_Name}
            value={staffList.filter((opt) =>
              candidateData.CI_CREmp.includes(opt.ED_Id)
            )}
            onChange={(event, newValue) => {
              const selectedValues = Array.isArray(newValue) ? newValue : [];
              setCandidateData({
                ...candidateData,
                CI_CREmp: selectedValues.map((option) => option.ED_Id),
              });
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Select a Staff"
                size="small"
              />
            )}
          />
        </Grid>

        {/* Documentation Officer */}
        <Grid item sx={{ padding: "5px" }} xs={12} sm={6} md={4} lg={4} xl={3}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
          >
            Documentation Officer{" "}
          </Typography>

          <Autocomplete
            multiple
            disableCloseOnSelect
            options={filteredOptions}
            getOptionLabel={(option) => option.ED_Name}
            value={staffList.filter((opt) =>
              candidateData.CI_DocOfficer.includes(opt.ED_Id)
            )}
            onChange={(event, newValue) => {
              const selectedValues = Array.isArray(newValue) ? newValue : [];
              setCandidateData({
                ...candidateData,
                CI_DocOfficer: selectedValues.map((option) => option.ED_Id),
              });
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Documentation Officer"
                size="small"
              />
            )}
          />
        </Grid>

        {/* Branch */}
        <Grid item sx={{ padding: "5px" }} xs={12} sm={6} md={4} lg={4} xl={3}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
          >
            Branch <span style={{ color: "red" }}> * </span>
          </Typography>
          <SelectInput
            value={candidateData.CI_Branch}
            name="CI_Branch"
            onChange={handleInputChange}
            options={branchList?.map((item) => ({
              value: item?.BL_Id,
              label: item?.BL_Name,
            }))}
            placeholder="Select a Branch"
            error={!!errors.CI_Branch}
            inputRef={inputRefs.CI_Branch}
            loading={loading?.branches}
          />
        </Grid>

        {/* Status */}
        <Grid item sx={{ padding: "5px" }} xs={12} sm={6} md={4} lg={4} xl={3}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
          >
            Status <span style={{ color: "red" }}> * </span>
          </Typography>
          <SelectInput
            name="CI_Status"
            value={candidateData?.CI_Status}
            onChange={handleInputChange}
            options={[
              { value: 1, label: "Active" },
              { value: 2, label: "Inactive" },
            ]}
            placeholder="Select Status"
          />
        </Grid>

        {/*  User Name */}
        <Grid item sx={{ padding: "5px" }} xs={12} sm={6} md={4} lg={4} xl={3}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
          >
            User Name <span style={{ color: "red" }}> * </span>
          </Typography>
          <TextInput
            label="User Name"
            placeholder="Enter User Name"
            name="CI_UserName"
            value={candidateData.CI_UserName}
            onChange={handleInputChange}
            isDisabled={true}
            error={!!errors.CI_UserName}
            inputRef={inputRefs.CI_UserName}
          />
        </Grid>
      </Grid>

      {/* Buttons */}
      <Grid container spacing={2} justifyContent="flex-end" sx={{ mt: 3 }}>
        <Grid item>
          <CommonButton
            variant="outlined"
            customColor="#B0BEC5"
            onClick={() => {
              navigate("/Candidates", {
                state: {
                  pagination: paginationState,
                  filterData: filterData,
                  expandedIds: expandedIds,
                  open: open,
                },
              });
            }}
          >
            Cancel
          </CommonButton>
        </Grid>
        <Grid item>
          <CommonButton
            variant="contained"
            customColor="#007BFF"
            onClick={handleSubmit}
          >
            Save
          </CommonButton>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default EditCandidate;
